const TOKEN_KEY = 'sa_creator_token';

export function getCreatorToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function setCreatorToken(t: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, t);
  } catch {
    /* private mode */
  }
}
export function clearCreatorToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private mode */
  }
}
